import { useFormContext } from 'react-hook-form';
import { ISignInFormData } from '../../domain/models/ISignInFormData';

export function useSignInFormContext() {
	return useFormContext<ISignInFormData>();
}
